module.exports = __webpack_public_path__ + "static/media/no_hotel.dc598f69.png";